// extracted by mini-css-extract-plugin
export default {"stack":"ResetPasswordScreen_stack__2rFDJ","screen":"ResetPasswordScreen_screen__vpzob","container":"ResetPasswordScreen_container__6LXSH"};